import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@components/atoms/Button'
import { Typography } from '@components/atoms/Typography'
import styles from './NotFoundPage.module.scss'

/**
 * SPA catch-all (`path: '*'`) for URLs that match no route. Rendered
 * shell-less (no nav chrome) so it works the same whether the user is
 * signed in or deep-linked to a dead URL. Brand-green ripple animation +
 * a single primary action back to the home (Approvals) list.
 */
export default function NotFoundPage() {
  const navigate = useNavigate()

  useEffect(() => {
    const previousTitle = document.title
    document.title = 'Page not found · ORO'
    return () => {
      document.title = previousTitle
    }
  }, [])

  return (
    <main className={styles.root}>
      <div className={styles.illustration} aria-hidden="true">
        <span className={styles.ring} />
        <span className={styles.ring} />
        <span className={styles.code}>404</span>
      </div>

      <div className={styles.copy}>
        <Typography variant="title-lg" weight="semibold" color="primary" as="h1">
          Page not found
        </Typography>
        <Typography variant="body-md" color="secondary" as="p">
          The page you&rsquo;re looking for doesn&rsquo;t exist or may have moved.
        </Typography>
      </div>

      <Button
        type="primary"
        size="lg"
        leadingIcon="home"
        onClick={() => navigate('/', { replace: true })}
      >
        Back to home
      </Button>
    </main>
  )
}
